<!-- Controls -->
<div id="ui-container">
    <div class="wrapper">
        <div class="controls-panel">
            <div *ngFor="let control of controls">
                <div> {{ control.keys }}: {{ control.desc}}</div>
            </div>
        </div>
    </div>
</div>
